import { Component, ElementRef, OnInit, Renderer2, TemplateRef, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { StorageKeys } from 'src/app/share/enums/storage.enum';
import { CompanyServiceService } from 'src/app/share/services/company-service/company-service.service';
import { DealersService } from 'src/app/share/services/dealers/dealers.service';
import { MasterMakeService } from 'src/app/share/services/master-make/master-make.service';
import { MasterModelService } from 'src/app/share/services/master-model/master-model.service';
import { StockService } from 'src/app/share/services/stock/stock.service';
import { StorageService } from 'src/app/share/services/storage-service/storage.service';
import { MessageService } from 'src/app/share/sharedsubject';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { PaymentAccountsService } from 'src/app/share/services/payment-account/payment-accounts.service';
@Component({
    selector: 'app-sale-dealer',
    templateUrl: './sale-dealer.component.html',
    styleUrls: ['./sale-dealer.component.scss'],
    standalone: false
})
export class SaleDealerComponent implements OnInit {
  customSearchFn = () => true;
  private offcanvasRef: any = null;
  errorMessage: string;
  addProductForm!: FormGroup;
  isLoading = false;
  dealerList: any[] = [];
  searchTerm: any = {};
  userDetails: any;
  paymentMode: string = "";
  showFullPaymentOption = true;
  showSplitPaymentOption = false;
  showSwpCharges = false;
  tyreModelObj: any = { page: 0 };
  selectedTyreModel: any;
  tyreSizeObj: any = { page: 0, searchTerm: '', list: [] };
  tyreMakeObj: any = { page: 0, searchTerm: '', list: [] };
  hasTax: boolean = true;
  checkSplitCount: boolean = true;
  dealerObj: any = { page: 0 };
  swpCharges: any = 0;
  endOfDealerList: boolean = false;
  filteredActiveBranches: any[] = [];
  paymentTypes = [
    { value: 'Full', label: 'Full' },
    { value: 'Split', label: 'Split' }
  ];
  paymentModes = [
    { value: 'Cash', label: 'Cash' },
    { value: 'BankTransfer', label: 'Bank Transfer' },
    { value: 'UPI', label: 'UPI' },
    { value: 'Card', label: 'Card (Charges will be applied)' },
    { value: 'BajajFinance', label: 'Bajaj Finance' },
    { value: 'Credit', label: 'Credit' }
  ];
  priceDetailsArray: { minPrice: number; maxPrice: number; avgPrice: number }[] = [];
  tyreModelList: { search: string, list: any[], page: number }[] = [{ search: '', list: [], page: 0 }];

  @ViewChild('accountFormModal') accountFormModal!: TemplateRef<any>;
  isEditMode: boolean = false;
  transactionId: string = '';
  preSelectedBranch: string = '';
  preSelectedMode: string = '';

  accountState: { [key: string]: { list: any[], page: number, loading: boolean, isLastPage: boolean } } = {
    Full: { list: [], page: 0, loading: false, isLastPage: false },
    Cash: { list: [], page: 0, loading: false, isLastPage: false },
    BankTransfer: { list: [], page: 0, loading: false, isLastPage: false },
    UPI: { list: [], page: 0, loading: false, isLastPage: false },
    Card: { list: [], page: 0, loading: false, isLastPage: false },
    BajajFinance: { list: [], page: 0, loading: false, isLastPage: false }
  };

  protected readonly faPlus = faPlus;
  protected readonly faTrash = faTrash;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly masterModelService: MasterModelService,
    private readonly companyService: CompanyServiceService,
    private readonly stockService: StockService,
    private readonly masterMakeService: MasterMakeService,
    private readonly dealersService: DealersService,
    private readonly router: Router,
    private readonly storageService: StorageService,
    private readonly elRef: ElementRef,
    private readonly renderer: Renderer2,
    private readonly messageService: MessageService,
    private readonly offcanvasService: NgbOffcanvas,
    private readonly paymentAccountsService: PaymentAccountsService,
    private readonly route: ActivatedRoute,
  ) {
    this.addProductForm = this.formBuilder.group({
      company: this.userDetails?.enrollmentType === 'Company' ? [null, Validators.required] : [null],
      dealerId: [null, [Validators.required]],
      brandName: [''],
      discount: [null],
      delayAfterDelivery: [null],
      creditLimit: [null],
      totalAmount: [null],
      swpCharges: [null],
      paymentType: ['Full', [Validators.required]],
      paymentMode: ['UPI', [Validators.required]],
      hasTax: [true],
      invoices: [null],
      totalPriceWithCharge: [null],
      cashAmount: [null],
      bankTransferAmount: [null],
      upiAmount: [null],
      cardAmount: [null],
      bajajFinanceAmount: [null],
      paymentAccount: [null],
      cashAccount: [null],
      bankTransferAccount: [null],
      upiAccount: [null],
      cardAccount: [null],
      bajajFinanceAccount: [null],
      descriptionNote: ['', [Validators.maxLength(120)]],
      editReason: [''],
      stock: this.formBuilder.array([this.createItemGroup()])
    });
    this.priceDetailsArray.push({ minPrice: 0, maxPrice: 0, avgPrice: 0 });
  }


  createItemGroup(): FormGroup {
    return this.formBuilder.group({
      tyreSize: [null, Validators.required],
      tyreMake: [null, Validators.required],
      tyreModel: [null],
      quantity: [null, [Validators.required, Validators.min(1), Validators.maxLength(10)]],
      tyresAmount: [null, [Validators.required, Validators.maxLength(10)]],
    });
  }

  get stock(): FormArray {
    return this.addProductForm.get('stock') as FormArray;
  }

  addItem(index: number): void {
    this.stock.push(this.createItemGroup());
    this.priceDetailsArray.push({ minPrice: 0, maxPrice: 0, avgPrice: 0 });
    this.tyreModelList.push({ search: '', list: [], page: 0});
  }

  removeItem(index: number): void {
    let quantity = (this.addProductForm.get('stock') as FormArray).controls[index].get('quantity')?.value;
    let tyresAmount = (this.addProductForm.get('stock') as FormArray).controls[index].get('tyresAmount')?.value;
    let totalAmt = this.addProductForm.value.totalAmount - (quantity * tyresAmount);
    if (quantity && tyresAmount) {
      this.addProductForm.get('totalAmount')?.setValue(totalAmt);
    }
    this.priceDetailsArray.splice(index, 1);
    this.stock.removeAt(index);
    this.tyreModelList.splice(index, 1);
  }

  ngOnInit(): void {
    this.userDetails = this.storageService.getDataFromLocalStorage(
      StorageKeys.SELF_DETAILS
    );
    if (this.userDetails?.enrollmentType === 'Company') {
      this.getAllCompanyList();
      this.addProductForm.get('company')?.setValidators([Validators.required]);
      this.addProductForm.get('company')?.setValue(null, { emitEvent: false });
    } else {
      this.addProductForm.get('company')?.setValue(this.userDetails?.company);
      this.onBranchChange();
    }
    this.initData();
    this.checkForEdit();
  }

  checkForEdit() {
    this.route.queryParams.subscribe((params: any) => {
      if (params['id']) {
        this.transactionId = params['id'];
        this.isEditMode = true;
        this.addProductForm.get('editReason')?.setValidators([Validators.required]);
        this.addProductForm.get('editReason')?.updateValueAndValidity();
        this.stockService.getTransactionDetails(params['id']).subscribe({
          next: (res: any) => {
            if (res.data) {
              this.patchTransactionData(res.data);
            }
          },
          error: (error: any) => {
            this.errorMessage = error?.error?.error?.message || 'Something went wrong';
          }
        })
      } else {
        this.getDealers();
      }
    });
  }

  onBranchChange() {
    const val = this.addProductForm.get('company')?.value;
    this.resetAllAccounts();
    if (val) {
      if (this.addProductForm.get('paymentType')?.value === 'Full') {
        const pm = this.addProductForm.get('paymentMode')?.value;
        if (pm && pm !== 'Credit') this.fetchAccounts('Full');
      } else {
        this.fetchAccounts('Cash');
        this.fetchAccounts('BankTransfer');
        this.fetchAccounts('UPI');
        this.fetchAccounts('Card');
        this.fetchAccounts('BajajFinance');
      }
    }
  }

  resetAllAccounts() {
    Object.keys(this.accountState).forEach(key => this.resetAccounts(key));
  }

  resetAccounts(type: string) {
    this.accountState[type] = { list: [], page: 0, loading: false, isLastPage: false };
    switch(type) {
      case 'Full': this.addProductForm.get('paymentAccount')?.setValue(null); break;
      case 'Cash': this.addProductForm.get('cashAccount')?.setValue(null); break;
      case 'BankTransfer': this.addProductForm.get('bankTransferAccount')?.setValue(null); break;
      case 'UPI': this.addProductForm.get('upiAccount')?.setValue(null); break;
      case 'Card': this.addProductForm.get('cardAccount')?.setValue(null); break;
      case 'BajajFinance': this.addProductForm.get('bajajFinanceAccount')?.setValue(null); break;
    }
  }

  fetchAccounts(type: string, isScroll: boolean = false) {
    const company = this.addProductForm.get('company')?.value;
    if (!company) return;

    let actualType = type === 'Full' ? this.addProductForm.get('paymentMode')?.value : type;
    if (!actualType || actualType === 'Credit') return;

    const requestType = actualType;

    if (isScroll) {
      this.accountState[type].page++;
    } else {
      this.accountState[type].page = 0;
      this.accountState[type].isLastPage = false;
      this.accountState[type].list = [];
    }

    if (this.accountState[type].loading || this.accountState[type].isLastPage) return;

    this.accountState[type].loading = true;

    this.paymentAccountsService.getCompanyPaymentAccount({ 
      company: company, paymentType: actualType, 
      page: this.accountState[type].page,status: true,
      sort: '_id', sortDir: 1
    }).subscribe({
      next: (res: any) => {
        this.accountState[type].loading = false;
        const currentActualType = type === 'Full' ? this.addProductForm.get('paymentMode')?.value : type;
        if (currentActualType !== requestType) return;

        if (res.data && res.data.length > 0) {
          const existingIds = new Set(this.accountState[type].list.map((a: any) => a._id));
          const newItems = res.data.filter((a: any) => !existingIds.has(a._id));
          this.accountState[type].list = [...this.accountState[type].list, ...newItems];
          this.selectDefaultAccount(res.data, type);
        } else {
          this.accountState[type].isLastPage = true;
        }
      },
      error: () => {
        this.accountState[type].loading = false;
      }
    });
  }

  private selectDefaultAccount(resData: any[], type: string) {
    if (this.accountState[type].page !== 0 || this.isEditMode) return;
    const defaultAcc = resData.find((a: any) => a.default);
    if (!defaultAcc) return;

    if (type === 'Full') {
      this.addProductForm.get('paymentAccount')?.setValue(defaultAcc._id);
      return;
    }

    const prefix = this.getControlPrefix(type);
    if (prefix) {
      const amount = this.addProductForm.get(`${prefix}Amount`)?.value;
      if (amount > 0) {
        this.addProductForm.get(`${prefix}Account`)?.setValue(defaultAcc._id);
      }
    }
  }

  onAccountScroll(type: string) {
    this.fetchAccounts(type, true);
  }

  getControlPrefix(type: string): string {
    switch(type) {
      case 'Cash': return 'cash';
      case 'BankTransfer': return 'bankTransfer';
      case 'UPI': return 'upi';
      case 'Card': return 'card';
      case 'BajajFinance': return 'bajajFinance';
      default: return '';
    }
  }

  getTyreSize() {
    const apiParams: any = { page: this.tyreSizeObj.page };
    if (this.tyreSizeObj.searchTerm) {
      apiParams.searchTerm = this.tyreSizeObj.searchTerm;
    }
    this.stockService.getTyreDetails(apiParams).subscribe((res: any) => {
      if (this.tyreSizeObj.page === 0) {
        this.tyreSizeObj.list = res.data || [];
      } else {
        this.tyreSizeObj.list = [...this.tyreSizeObj.list, ...(res.data || [])];
      }
    });
  }

  getTyreMake() {
    this.masterMakeService.getTyreMakeBySize(this.tyreMakeObj.page, this.tyreMakeObj.searchTerm).subscribe((res: any) => {
      if (this.tyreMakeObj.page === 0) {
        this.tyreMakeObj.list = res.data || [];
      } else {
        this.tyreMakeObj.list = [...this.tyreMakeObj.list, ...(res.data || [])];
      }
    });
  }

  initData() {
    this.tyreSizeObj.searchTerm = "";
    this.tyreSizeObj.page = 0;
    this.tyreMakeObj.searchTerm = "";
    this.tyreModelObj.name = "";
    this.getTyreSize();
    this.getTyreMake();
  }

  onSizeClose() {
    if (this.tyreSizeObj.searchTerm) {
      this.tyreSizeObj.page = 0;
      this.tyreSizeObj.searchTerm = '';
      this.getTyreSize();
    }
  }

  onMakeClose() {
    if (this.tyreMakeObj.searchTerm) {
      this.tyreMakeObj.page = 0;
      this.tyreMakeObj.searchTerm = '';
      this.getTyreMake();
    }
  }

  onModelClose(index: number) {
    if (this.tyreModelList[index].search) {
      this.tyreModelList[index].page = 0;
      this.tyreModelList[index].search = '';
      
      this.tyreModelObj.page = 0;
      this.tyreModelObj.name = '';
      
      let selectedModel: any = this.stock?.controls[index];
      let value = selectedModel?.controls['tyreMake'].value;
      this.tyreModelObj.tyreMake = value;
      
      this.getTyreModel(this.tyreModelObj, index);
    }
  }

  patchTransactionData(data: any) {
    if (data.dealer) {
      const dealerId = data?.dealer?._id || '';
      const dealerName = data?.dealer?.name || 'Unknown Dealer';
      this.dealerList = [{ _id: dealerId, name: dealerName }];
    }

    this.addProductForm.patchValue({
      company: data.company?._id || data.company,
      discount: data.discount,
      totalAmount: data.totalAmount,
      swpCharges: data.swpCharges,
      paymentType: data.paymentType,
      hasTax: data.hasTax,
      dealerId: data.dealer?._id,
      creditLimit: data.creditLimit,
      delayAfterDelivery: data.delayAfterDelivery,
      descriptionNote: data.descriptionNote
    });
    console.log(this.dealerList, this.addProductForm);
    
    this.addProductForm.get('company')?.disable();
    this.addProductForm.get('dealerId')?.disable();
    this.addProductForm.get('descriptionNote')?.disable();

    const stockFormArray = this.addProductForm.get('stock') as FormArray;
    stockFormArray.clear();
    this.priceDetailsArray = [];
    this.tyreModelList = [];

    data.stock.forEach((item: any, index: number) => {
      const group = this.createItemGroup();
      group.patchValue({
        tyreSize: item.tyreSize,
        tyreMake: item.tyreMake,
        tyreModel: item.tyreModel,
        quantity: item.quantity,
        tyresAmount: item.tyresAmount,
      });
      
      group.get('tyreSize')?.disable();
      group.get('tyreMake')?.disable();
      group.get('tyreModel')?.disable();

      stockFormArray.push(group);
      
      this.priceDetailsArray.push({ minPrice: 0, maxPrice: 0, avgPrice: 0 });
      this.tyreModelList.push({ search: '', list: [], page: 0 });
      this.getFreightDetails(index);
    });

    this.showPayDetailsForm(data.paymentType);

    if (data.paymentAccounts && Array.isArray(data.paymentAccounts)) {
      data.paymentAccounts.forEach((pa: any) => {
        const accountId = pa.paymentId?._id || pa.paymentId;
        const accountName = pa.paymentId?.accountName || 'Unknown Account';
        const amount = pa.amount;
        const listType = data.paymentType === 'Full' ? 'Full' : pa.mode;

        if (this.accountState[listType]) {
          const exists = this.accountState[listType].list.find((a: any) => a._id === accountId);
          if (!exists) {
            this.accountState[listType].list.push({ _id: accountId, accountName: accountName });
          }
        }
        
        if (data.paymentType === 'Full') {
          this.addProductForm.get('paymentMode')?.patchValue(pa.mode);
          this.resetAccounts('Full');
          this.fetchAccounts('Full');
          this.addProductForm.get('paymentAccount')?.patchValue(accountId);
        } else {
          const prefix = this.getControlPrefix(pa.mode);
          if (prefix) {
            this.addProductForm.get(`${prefix}Amount`)?.patchValue(amount);
            this.addProductForm.get(`${prefix}Account`)?.patchValue(accountId);
          }
        }
      });
    }

    if (data.paymentType === 'Split') {
      this.resetAllAccounts();
      this.fetchAccounts('Cash');
      this.fetchAccounts('BankTransfer');
      this.fetchAccounts('UPI');
      this.fetchAccounts('Card');
      this.fetchAccounts('BajajFinance');
      setTimeout(() => this.splitAmountSum());
    }
  }


  selectMake(value: any, index: any) {
    let selectedTyre: any = this.stock?.controls[index];
    selectedTyre?.controls['tyreModel'].setValue(null);
    this.tyreModelObj.tyreMake = value || ''
    this.tyreModelObj.name = '';
    this.tyreModelObj.page = 0;
    this.tyreModelList[index].search = '';
    this.tyreModelList[index].page = 0;
    this.tyreModelList[index].list = [];
    if (value) {
      this.getTyreModel(this.tyreModelObj, index);
      this.getFreightDetails(index);
    }
  }

  getTyreModel(selectedMake: any, index: number) {
    this.masterModelService.getTyreModelList(selectedMake, this.tyreModelObj).subscribe((res: any) => {
      if (this.tyreModelObj.page == 0) {
        this.tyreModelList[index].list = res.data || [];
      }
      else {
        this.tyreModelList[index].list = this.tyreModelList[index].list.concat(res.data || []);
      }
    });
  }


  getDealers() {
    this.dealersService.getDealerDetails(this.dealerObj).subscribe((res: any) => {
      this.dealerList = this.dealerList.concat(res.data || []);
      if (res.data.length === 0) {
        this.endOfDealerList = true;
      }
    })
  }

  getAllCompanyList() {
    this.companyService.getToCompanyList().subscribe((res: any) => {
      this.filteredActiveBranches = res.data?.filter((c: any) => c.status === 'Active') || [];
    });
  }

  onTyreMakeInputChange(event: any) {
    this.tyreMakeObj.page = 0;
    let tyreMakeSearch = event?.term ? event.term : '';
    this.tyreMakeObj.searchTerm = tyreMakeSearch;
    this.tyreMakeObj.list = [];
    this.getTyreMake();
  }

  saveProduct() {
    if (!this.validateSplitAmount() || this.isLoading) return
    if (this.isEditMode) {
      this.saveEditedProduct()
    } else {
      this.saveNewProduct()
    }
  }


  validateSplitAmount(): boolean {
    const paymentType = this.addProductForm.get('paymentType')?.value;
    if (paymentType === 'Split') {
      const totalAmount = this.addProductForm.get('totalAmount')?.value || 0;
      const splitAmt =
        (this.addProductForm.get('upiAmount')?.value || 0) +
        (this.addProductForm.get('bankTransferAmount')?.value || 0) +
        (this.addProductForm.get('cashAmount')?.value || 0) +
        (this.addProductForm.get('cardAmount')?.value || 0) +
        (this.addProductForm.get('bajajFinanceAmount')?.value || 0);
      if (splitAmt !== totalAmount) {
        this.errorMessage = `Split amount total (₹${splitAmt}) does not match the order total (₹${totalAmount}). Please adjust the split amounts.`;
        return false;
      }
    }
    return true;
  }

  saveEditedProduct() {
    this.isLoading = true;
    let payload: any = {}
    payload = this.generateEditPayload()
    this.stockService.saveStockOutEdit(this.transactionId,payload).subscribe({
      next: (res: any) => {
      setTimeout(() => {
        this.messageService.sendMessage(res.message || "Transaction edited successfully");
      })
      this.router.navigate(['/order-list'])
      this.errorMessage = ''
    },
      error: (error) => {
      this.isLoading = false;
      this.errorMessage = error?.error?.error?.message || (Array.isArray(error?.error?.message) ? (error?.error?.message[0]) : (error?.error?.message || error?.message || error?.error))
    }
    })
  }

  saveNewProduct() {
    this.isLoading = true;
    let payload: any = { }
    payload = this.generatePayload()
    this.stockService.saveDealerStockOutDetails(payload).subscribe({
      next: (res: any) => {
      setTimeout(() => {
        this.messageService.sendMessage(res.message);
      })
      this.router.navigate(['/order-list'])
      this.errorMessage = ''
    },
      error: (error) => {
      this.isLoading = false;
      this.errorMessage = error?.error?.error?.message || (Array.isArray(error?.error?.message) ? (error?.error?.message[0]) : (error?.error?.message || error?.message || error?.error))
    }
    })
  }

  generatePayload() {
    let payload: any = {}
    if (!this.addProductForm.value) return {}
    let formValues = { ...this.addProductForm.value }
    payload = {
      company: formValues.company,
      creditLimit: formValues.creditLimit,
      dealerId: formValues.dealerId,
      delayAfterDelivery: formValues.delayAfterDelivery,
      descriptionNote: formValues.descriptionNote,
      discount: formValues.discount,
      hasTax:true,
      paymentAccounts: this.getPaymentAccountsPayload(),
      paymentType: formValues.paymentType,
      stock: formValues.stock,
      swpCharges: formValues.swpCharges,
      totalAmount: formValues.totalAmount,
    }
    if (formValues.paymentType === 'Full' && formValues.paymentMode === 'Credit') {
      payload.paymentMode = 'Credit'
    }
    return payload;
  }

  generateEditPayload() {
    let payload: any = {}
    if (!this.addProductForm.value) return {}
    let formValues = { ...this.addProductForm.getRawValue() }
    payload = {
      company: formValues.company,
      creditLimit: formValues.creditLimit,
      dealerId: formValues.dealerId,
      delayAfterDelivery: formValues.delayAfterDelivery,
      descriptionNote: formValues.descriptionNote,
      discount: formValues.discount,
      hasTax: true,
      paymentAccounts: this.getPaymentAccountsPayload(),
      paymentType: formValues.paymentType,
      stock: formValues.stock,
      swpCharges: formValues.swpCharges,
      totalAmount: formValues.totalAmount,
      reason: formValues.editReason,
    }
    if (formValues.paymentType === 'Full' && formValues.paymentMode === 'Credit') {
      payload.paymentMode = 'Credit'
    }
    return payload;
  }

  showPayDetailsForm(paymentType: any) {
    if (paymentType == "Full") {
      this.showFullPaymentOption = true;
      this.showSplitPaymentOption = false;
      this.addProductForm.get('upiAmount')?.setValue(null);
      this.addProductForm.get('cardAmount')?.setValue(null);
      this.addProductForm.get('bankTransferAmount')?.setValue(null);
      this.addProductForm.get('cashAmount')?.setValue(null);
      this.addProductForm.get('bajajFinanceAmount')?.setValue(null);
      if (!this.isEditMode) {
        this.addProductForm.get('paymentMode')?.setValue('UPI');
      }
      this.checkSplitCount = true;
      this.addProductForm.get('paymentMode')?.setValidators(Validators.required);
      this.addProductForm.get('paymentMode')?.updateValueAndValidity();
      if (!this.isEditMode) {
        this.resetAccounts('Full');
        this.fetchAccounts('Full');
      }
    } else {
      this.showFullPaymentOption = false;
      this.showSplitPaymentOption = true;
      this.checkSplitCount = false;
      this.addProductForm.get('paymentMode')?.clearValidators();
      this.addProductForm.get('paymentMode')?.updateValueAndValidity();
      if (!this.isEditMode) {
        this.resetAllAccounts();
        this.fetchAccounts('Cash');
        this.fetchAccounts('BankTransfer');
        this.fetchAccounts('UPI');
        this.fetchAccounts('Card');
        this.fetchAccounts('BajajFinance');
      }
    }
    this.showSwpCharges = false;
    this.addProductForm.get('swpCharges')?.setValue(null);
    this.calculateTotalService();
  }

  onScrollTyreSize() {
    if (this.tyreSizeObj.list.length % 20 === 0) {
      this.tyreSizeObj.page++;
      this.getTyreSize();
    }
  }

  calculateTotalService() {
    this.showSwpCharges = false;
    let serviceTotalCal =
      Number(this.addProductForm.get('sensors')?.value || 0) +
      Number(this.addProductForm.get('n2Air')?.value || 0) +
      Number(this.addProductForm.get('puncture')?.value || 0) +
      Number(this.addProductForm.get('spray')?.value || 0) +
      Number(this.addProductForm.get('balancing')?.value || 0) +
      Number(this.addProductForm.get('airNecks')?.value || 0);
    if (!this.hasTax) {
      serviceTotalCal =
        Math.ceil(Number(this.addProductForm.get('sensors')?.value || 0) * 1.18) +
        Math.ceil(Number(this.addProductForm.get('n2Air')?.value || 0) * 1.18) +
        Math.ceil(Number(this.addProductForm.get('puncture')?.value || 0) * 1.18) +
        Math.ceil(Number(this.addProductForm.get('spray')?.value || 0) * 1.18) +
        Math.ceil(Number(this.addProductForm.get('balancing')?.value || 0) * 1.18) +
        Math.ceil(Number(this.addProductForm.get('airNecks')?.value || 0) * 1.18);
    }
    this.addProductForm.get('serviceAmount')?.setValue(serviceTotalCal);
    let tyreAmount = 0;
    (this.addProductForm.get('stock') as FormArray).controls.forEach((x: any) => {
      tyreAmount += (x.get('quantity')?.value || 0) * ((x.get('tyresAmount').value || 0));
    });
    if (!this.hasTax) {
      tyreAmount = Math.ceil(((this.addProductForm.get('totalAmount')?.value || 0) * ((this.addProductForm.get('quantity')?.value || 0))) * 1.28);
    }
    let totalAmt = serviceTotalCal + tyreAmount;
    let discount = Math.ceil((this.addProductForm.get('discount')?.value || 0));
    const discountControl = this.addProductForm.get('discount');

    if (discount > 0 && discount >= totalAmt) {
      discountControl?.setErrors({ discountExceeded: true });
    } else {
      if (discountControl?.hasError('discountExceeded')) {
        discountControl.setErrors(null);
      }
      totalAmt = totalAmt - discount;
    }
    const payMode = this.addProductForm.get('paymentMode')?.value;
    const payType = this.addProductForm.get('paymentType')?.value;
    const cardAmt = Number(this.addProductForm.get('cardAmount')?.value || 0);

    this.swpCharges = this.getCalculatedSwpCharges(totalAmt, payType, payMode, cardAmt);
    totalAmt = totalAmt + this.swpCharges;
    this.addProductForm.get('totalAmount')?.setValue(totalAmt);
  }

  private getCalculatedSwpCharges(totalAmt: number, payType: string, payMode: string, cardAmt: number): number {
    if (payType === "Full" && payMode === "Card") {
      this.showSwpCharges = true;
      let swpChargePer = this.addProductForm.get('swpCharges')?.value || 0;
      if (swpChargePer < 0 || swpChargePer > 100 || Number.isNaN(swpChargePer)) {
        this.addProductForm.get('swpCharges')?.setValue(null);
        swpChargePer = 0;
      }
      return Math.ceil(((swpChargePer / 100) * totalAmt));
    } else if (payType === "Split" && cardAmt > 0) {
      this.showSwpCharges = false;
      let swpChargePer = this.addProductForm.get('swpCharges')?.value || 0;
      if (swpChargePer < 0 || swpChargePer > 100 || Number.isNaN(swpChargePer)) {
        this.addProductForm.get('swpCharges')?.setValue(null);
        swpChargePer = 0;
      }
      return Math.ceil(((swpChargePer / 100) * cardAmt));
    } else {
      this.addProductForm.get('swpCharges')?.setValue(null);
      return 0;
    }
  }

  onTyreSizeInputChange(event: any) {
    this.tyreSizeObj.page = 0;
    let tyreSizeSearch = event?.term ? event.term : '';
    this.tyreSizeObj.searchTerm = tyreSizeSearch;
    this.tyreSizeObj.list = [];
    this.getTyreSize();
  }


  onTyreModelInputChange(event: any, index: number) {
    this.tyreModelObj.page = 0
    this.tyreModelList[index].page = 0;
    let tyreModelSearch = event?.term ? event.term : '';
    this.tyreModelList[index].search = tyreModelSearch
    let selectedModel: any = this.stock?.controls[index];
    let value = selectedModel?.controls['tyreMake'].value;
    this.tyreModelObj.tyreMake = value;
    this.tyreModelObj.name = tyreModelSearch
    this.getTyreModel(this.tyreModelObj, index);
  }

  scroll(index: number) {
    if (this.tyreModelList[index].list.length % 20 === 0) {
      this.tyreModelList[index].page++
      this.tyreModelObj.page = this.tyreModelList[index].page;
      this.tyreModelObj.name = this.tyreModelList[index].search;
      let selectedModel: any = this.stock?.controls[index];
      let value = selectedModel?.controls['tyreMake'].value;
      this.tyreModelObj.tyreMake = value;
      this.getTyreModel(this.tyreModelObj, index);
    }
  }

  splitAmountSum() {
    const sumAmount = this.elRef.nativeElement.querySelector('#sumAmount');
    const payType = this.addProductForm.get('paymentType')?.value;
    const upiAmount = this.addProductForm.get('upiAmount')?.value;
    const bankTransferAmount = this.addProductForm.get('bankTransferAmount')?.value;
    const cashAmount = this.addProductForm.get('cashAmount')?.value;
    const cardAmount = this.addProductForm.get('cardAmount')?.value;
    const bajajFinanceAmount = this.addProductForm.get('bajajFinanceAmount')?.value;
    let count = 0;
    if (upiAmount) {
      count++;
    }
    if (bankTransferAmount) {
      count++;
    }
    if (cashAmount) {
      count++;
    }
    if (cardAmount) {
      count++;
    }
    if (bajajFinanceAmount) {
      count++;
    }
    if (payType == "Split" && count >= 2) {
      this.checkSplitCount = true;

    } else {
      this.checkSplitCount = false;
    }

    const splitAmt = (this.addProductForm.get('upiAmount')?.value || 0) +
      (this.addProductForm.get('bankTransferAmount')?.value || 0) +
      (this.addProductForm.get('cashAmount')?.value || 0) +
      (this.addProductForm.get('cardAmount')?.value || 0) +
      (this.addProductForm.get('bajajFinanceAmount')?.value || 0);
      
    if (sumAmount) {
      this.renderer.setProperty(sumAmount, 'innerHTML', splitAmt);
    }
    
    const splitTypes = ['Cash', 'BankTransfer', 'UPI', 'Card', 'BajajFinance'];
    splitTypes.forEach(type => {
      const prefix = this.getControlPrefix(type);
      const amountControl = this.addProductForm.get(`${prefix}Amount`);
      const accountControl = this.addProductForm.get(`${prefix}Account`);
      
      if (amountControl && accountControl) {
        if (amountControl.value > 0) {
          if (!accountControl.value) {
            const defaultAcc = this.accountState[type].list.find((a: any) => a.default);
            if (defaultAcc) {
              accountControl.setValue(defaultAcc._id);
            }
          }
        } else {
          accountControl.setValue(null);
        }
      }
    });

    const cardAmt = this.addProductForm.get('cardAmount')?.value;
    if (!cardAmt || Number(cardAmt) <= 0) {
      this.addProductForm.get('swpCharges')?.setValue(null);
    }
    this.calculateTotalService();
  }


  onDealerInputChange(event: any) {
    this.dealerObj.page = 0;
    this.dealerList = [];
    let delearSearch = event?.term ? event.term : '';
    this.dealerObj.searchTerm = delearSearch;
    this.getDealers();
  }

  scrollDealer() {
    if (this.endOfDealerList) {
      return;
    } else {
      this.dealerObj.page++
      this.getDealers()
    }
  }

  selectedDealer(selectedDealer: any) {
    if (!selectedDealer) {
      this.addProductForm.controls['creditLimit'].setValue(null);
      this.addProductForm.controls['delayAfterDelivery'].setValue(null);
      return;
    }
    this.addProductForm.controls['creditLimit'].setValue(selectedDealer.creditLimit);
    this.addProductForm.controls['delayAfterDelivery'].setValue(selectedDealer.delayAfterDelivery);
  }

  getFreightDetails(index: any) {
    let formValues = this.addProductForm.getRawValue()
    const tyreSize = formValues.stock[index].tyreSize;
    const tyreMake = formValues.stock[index].tyreMake;
    const tyreModel = formValues.stock[index].tyreModel;
    let payload : any ={
      tyreSize,
      tyreMake,
      tyreModel
    }
    if (!tyreSize || !tyreMake) {
      return;
    }
    this.stockService.freightDetails(payload).subscribe({
      next: (res: any) => {
        setTimeout(() => {
          this.priceDetailsArray[index] = {
            minPrice: res?.data?.minPrice || 0,
            maxPrice: res?.data?.maxPrice || 0,
            avgPrice: res?.data?.avgPrice || 0,
          };
        });
        this.errorMessage = '';
      },
      error: (error) => {
        this.errorMessage = error?.error?.error?.message;
      }
    });
  }

  onPaymentModeChange(event: any): void {
    this.paymentMode = event;
    if (this.addProductForm.get('paymentType')?.value === 'Full') {
      this.resetAccounts('Full');
      if (this.paymentMode && this.paymentMode !== 'Credit') {
        this.fetchAccounts('Full');
      }
    }
    this.calculateTotalService(); 
  }

  getPaymentAccountsPayload(): any[] {
    const paymentType = this.addProductForm.get('paymentType')?.value;
    let accounts: any[] = [];
    
    if (paymentType === 'Full') {
      const paymentMode = this.addProductForm.get('paymentMode')?.value;
      if (paymentMode && paymentMode !== 'Credit') {
        let acc = this.addProductForm.get('paymentAccount')?.value;
        if (!acc) {
          const defaultAcc = this.accountState['Full'].list.find((a: any) => a.default);
          if (defaultAcc) acc = defaultAcc._id;
        }
        if (acc) accounts.push({ paymentId: acc, amount: this.addProductForm.get('totalAmount')?.value, mode: paymentMode });
      }
    } else if (paymentType === 'Split') {
      const splitTypes = ['Cash', 'BankTransfer', 'UPI', 'Card', 'BajajFinance'];
      splitTypes.forEach(type => {
        const prefix = this.getControlPrefix(type);
        const amountControl = this.addProductForm.get(`${prefix}Amount`);
        if (amountControl && amountControl.value > 0) {
          let acc = this.addProductForm.get(`${prefix}Account`)?.value;
          if (!acc) {
            const defaultAcc = this.accountState[type].list.find((a: any) => a.default);
            if (defaultAcc) acc = defaultAcc._id;
          }
          if (acc) accounts.push({ paymentId: acc, amount: amountControl.value, mode: type });
        }
      });
    }
    return accounts;
  }

  addNewPaymentAccount(paymentMode?: string) {
    this.preSelectedBranch = this.addProductForm.get('company')?.value || '';
    this.preSelectedMode = paymentMode || '';
    this.offcanvasRef = this.offcanvasService.open(this.accountFormModal, {
      position: 'end',
      panelClass: 'payment-account-detail-offcanvas',
      backdrop: 'static',
      keyboard: false
    });
  }

  onAccountSave(data: any) {
    this.offcanvasRef?.close();
    const savedMode = data.paymentType;
    if (this.addProductForm.get('paymentType')?.value === 'Full') {
      this.resetAccounts('Full');
      this.fetchAccounts('Full');
    } else {
      this.resetAccounts(savedMode);
      this.fetchAccounts(savedMode);
    }
  }
}
